import request from '@/utils/request'

// 获取合同列表
export function getContractList() {
	return request({
		url: '/Company/getContractList',
		method: 'post'
	})
}

// 根据条件获取合同列表
export function getContractListQuery(data) {
	return request({
		url: '/Company/getContractList',
		method: 'post',
		data
	})
}

// 编辑合同模版
export function editCollect(data) {
	return request({
		url: '/Company/editCollect',
		method: 'post',
		data
	})
}

// 首页统计数量接口
export function getIndexData(data) {
	return request({
		url: '/Customer/getIndexData',
		method: 'post',
		data
	})
}

// 添加收藏模版
export function addCollect(data) {
	return request({
		url: '/Company/addCollect',
		method: 'post',
		data
	})
}

// 增加下载次数
export function addDownLoadTimes(data) {
	return request({
		url: '/Company/addDownLoadTimes',
		method: 'post',
		data
	})
}

// 删除模版
export function deleteCollect(data) {
	return request({
		url: '/Company/deleteCollect',
		method: 'post',
		data
	})
}

// 删除合同模版
export function deleteContract(data) {
	return request({
		url: '/Company/deleteContract',
		method: 'post',
		data
	})
}

// 上传e签宝获取id
export function uploadSignFile(data) {
	return request({
		url: '/Enterprise/Process/uploadSignFile',
		method: 'post',
		data
	})
}

// 添加发送意向合同
export function sendIntentionContract(data) {
	return request({
		url: '/Customer/sendIntentionContract',
		method: 'post',
		data
	})
}

// 获取签署意向详情
export function processDetail(data) {
	return request({
		url: '/Enterprise/Process/processDetail',
		method: 'post',
		data
	})
}

// 解除合同发起
export function dissolveContract(data) {
	return request({
		url: '/Customer/dissolveContract',
		method: 'post',
		data
	})
}

// 撤销合同发起
export function stopDraft(data) {
	return request({
		url: '/Enterprise/Process/stopDraft',
		method: 'post',
		data
	})
}

// 添加正式合同
export function sendFranchiseContract(data) {
	return request({
		url: '/Customer/sendFranchiseContract',
		method: 'post',
		data
	})
}

// 首页统计图查询接口
export function getStatistics(data) {
	return request({
		url: '/Enterprise/Customer/getStatistics',
		method: 'post',
		data
	})
}

// 获取发起方签署链接
export function getSignUrl(data) {
	return request({
		url: '/CustomerProcess/getSignUrl',
		method: 'post',
		data
	})
}

// 获取合同类型列表
export function getContractCategorySelectList(data) {
	return request({
		url: '/Contract/getContractCategorySelectList',
		method: 'post',
		data
	})
}

// 合同列表
export function getShowContractTemplateList(data) {
	return request({
		url: '/Contract/getShowContractTemplateList',
		method: 'post',
		data
	})
}

// 合同模板点赞/取消 操作
export function contractTemplateLikeOperation(data) {
	return request({
		url: '/Contract/contractTemplateLikeOperation',
		method: 'post',
		data
	})
}
// 合同模板收藏/取消 操作

export function contractTemplateCollectionOperation(data) {
	return request({
		url: '/Contract/contractTemplateCollectionOperation',
		method: 'post',
		data
	})
}
// 合同模板下载
export function contractTemplateDownloadOperation(data) {
	return request({
		url: '/Contract/contractTemplateDownloadOperation',
		method: 'post',
		data
	})
}
// 我的收藏
export function contractTemplateMyCollection(data) {
	return request({
		url: '/Contract/contractTemplateMyCollection',
		method: 'post',
		data
	})
}

// 获取合同管理离得企业合同列表
export function getContractListCustomerProcess(data) {
	return request({
		url: '/CustomerProcess/getContractList',
		method: 'post',
		data
	})
}

// 获取已完成合同列表
export function getFinishContractList(data) {
	return request({
		url: '/CustomerProcess/getFinishContractList',
		method: 'post',
		data
	})
}
// 更新合同相关金额
export function updateAmount(data) {
	return request({
		url: '/CustomerProcess/updateAmount',
		method: 'post',
		data
	})
}

// 推送记录列表
export function getRecordsList(data) {
	return request({
		url: '/CustomerProcess/getRecordsList',
		method: 'post',
		data
	})
}

// 获取企业未读推送记录状态
export function getRecordsstatus(data) {
	return request({
		url: '/CustomerProcess/getRecordsstatus',
		method: 'post',
		data
	})
}
